import ListHeader from '@/common/components/ListHeader'
import Tabs from '@/common/components/Tabs'
import useUserPermissions from '@/common/hooks/useUserPermissions'
import HomologatedList from '@/features/modelIntegrationCodes/pages/List/tabs/HomologatedList'
import PendingList from '@/features/modelIntegrationCodes/pages/List/tabs/PendingList'
import { CaravanIcon } from 'lucide-react'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const PENDING_PERMISSION = 'Admin::EquipmentModels::PendingIntegrationFilter'
const HOMOLOGATED_PERMISSION = 'Admin::EquipmentModels::IntegrationCodesFilter'

const ModelIntegrationCodesList = () => {
  const { userPermissionsSet, isUserPermissionsPending } = useUserPermissions()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isUserPermissionsPending && location.pathname.split('/').filter(Boolean).length === 1) {
      if (userPermissionsSet.has(PENDING_PERMISSION)) {
        return navigate('pending')
      }

      return navigate('homologated')
    }
  }, [isUserPermissionsPending, location.pathname])

  return (
    <div className="flex flex-col gap-4 max-h-[calc(100vh-128px)]">
      <ListHeader Icon={<CaravanIcon className="size-10" strokeWidth={1.5} />} title="Homologação de Modelos" />

      <Tabs
        tabsListClassName="flex h-auto flex-row flex-wrap justify-start w-full bg-transparent rounded-none"
        tabsTriggerClassName="flex-1 h-8 transition-none duration-0 rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
        tabsContentClassName="mt-4 flex-1 min-h-0"
        keepFilterParams
        isLoading={isUserPermissionsPending}
        skeletonsCount={2}
        tabsList={[
          {
            value: 'pending',
            label: 'Pendentes',
            body: <PendingList />,
            operationKlassToCheckPermission: PENDING_PERMISSION,
          },
          {
            value: 'homologated',
            label: 'Homologados',
            body: <HomologatedList />,
            operationKlassToCheckPermission: HOMOLOGATED_PERMISSION,
          },
        ]}
      />
    </div>
  )
}

export default ModelIntegrationCodesList
